export class ConsolidatedPosition {

    public totalNetEquity: number = null;
    public totalFixedIncome: number = null;
    public accountBalance: number = null;
    public totalExchange: number = null;
    public totalAvailableOnAccountD0: number = null;
    public entryD0: number = null;
    public stockOperationsPending: number = null;
    public stockPendingOperations: number = null;
    public stockDTPendingOperations: number = null;
    public futurePendingOperations: number = null;
    public futureDTPendingOperations: number = null;
    public optionsPendingOperations: number = null;
    public totalOperationGuarantee: number = null;
    public totalFunds: number = null;
    public stockDTEquityProjects: number = null;
    public totalGuarantee: number = null;
    public lastUpdatePosition: string = null;
    public totalRequiredGuaranteeFactor: number = null;
    public leverageLevel: number = null;

    public static createMock(): ConsolidatedPosition {
        return {
            totalNetEquity: 0,
            totalFixedIncome: 0,
            accountBalance: 0,
            totalExchange: 500,
            totalAvailableOnAccountD0: 0,
            entryD0: 0,
            stockOperationsPending: 0,
            stockPendingOperations: 0,
            stockDTPendingOperations: 0,
            futurePendingOperations: 0,
            futureDTPendingOperations: 0,
            optionsPendingOperations: 0,
            totalOperationGuarantee: 0,
            totalFunds: 0,
            stockDTEquityProjects: 0,
            totalGuarantee: 100,
            lastUpdatePosition: '2019-02-19T19:23:16.9428522-03:00',
            totalRequiredGuaranteeFactor: 0,
            leverageLevel: 0,
        };
    }
}
